import { stdObject } from "../data/types/stdObject";

export const getKey = (prefix: string, data: stdObject) => {
  const res = Object.keys(data).filter((e: string) => e.startsWith(prefix));
  return res.length > 0 ? res[0].slice(-3) : "";
};
